import { Button, Col, InputNumber, Typography } from "antd";
import { Dispatch, SetStateAction } from "react";
import { useKitsProducts } from "../../../../modules/kits";
import { WrapperModalKits } from "../../../../modules/kits/ui/styled";
import { SimpleInputSelect } from "../inputs";

const { Title, Text } = Typography;

interface Props {
    modalIsOpen: boolean
    setModalIsOpen: Dispatch<SetStateAction<boolean>>
}
export const ModalKitsProducts = ({modalIsOpen,setModalIsOpen}:Props) => {
    const { arrOptionsProducts, changeSelectValue, onSubmitCreateProductForKit, onInputKeyDown, selectedValue, quantity, changeQuantity, isLoading } = useKitsProducts()
  return (
    <WrapperModalKits
      title={`Agregar un nuevo producto al kit`}
      open={modalIsOpen}
      width={"320px"}
      destroyOnClose
      onClose={()=>setModalIsOpen(false)}
    >
        <Col
          span={24}
          style={{
            display: "flex",
            marginTop: "10px",
            justifyContent: "center",
            alignItems: "flex-start",
            flexDirection: "column",
          }}
        >
          <Title style={{ marginBottom: "1.5px" }} level={5}>
            Producto:
          </Title>
          <SimpleInputSelect
              showSearch
              valueSelect={selectedValue}
              onChange={changeSelectValue}
              label={"Seleccione producto"}
              onInputKeyDown={onInputKeyDown}
              dataOptions={
                arrOptionsProducts || []
              }
              maxWidth="100%"
            />
        </Col>
        <Col
          span={24}
          style={{
            display: "flex",
            marginTop: "10px",
            justifyContent: "center",
            alignItems: "flex-start",
            flexDirection: "column",
          }}
        >
          <Title style={{ marginBottom: "1.5px" }} level={5}>
            Cantidad:
          </Title>
          <InputNumber
            min={1}
            value={quantity}
            onChange={(val) => changeQuantity(val || 1)}
            style={{ width: "100%" }}
          />
          <Text type="secondary" style={{ marginTop: 6, fontSize: 12 }}>
            Solo se pueden agregar productos activos con stock disponible.
          </Text>
        </Col>

      <Button
        style={{
          width: "100%",
          marginTop: 10,
        }}
        type="primary"
        shape="round"
        size="large"
        onClick={()=>{
            void onSubmitCreateProductForKit().then((ok) => {
              if (ok) setModalIsOpen(false);
            });
        }}
        loading={isLoading}
      >
        Agregar producto al kit
      </Button>
    </WrapperModalKits>
  )
}
